import { i18n } from '@/commons/utils';
import { formatUrl } from './payment-utils';

export function B2BBlock(page) {
  const block = this;

  block.init = params => {
    block.container = params.container;
    block.header = block.container.querySelector('.dkt-block-header');
    block.content = block.container.querySelector('.dkt-block-content');
    block.id = block.container.getAttribute('data-payment-type-id');
    block.multiEnabled = block.container.getAttribute('data-multi-enabled');
    block.content.innerHTML = block.template();
    block.orderId = params.orderId;
    block.state = {
      selected: params.selected || false,
      hasError: false
    };
    block.fields = {
      invoiceNumber: {
        input: document.getElementById('tb-invoice-number'),
        container: document.getElementById('invoice-number-field'),
        max: 23
      }
    };
    block.events();
    if (block.state.selected === true) {
      block.select();
    }
  };

  block.template = () => `
    <p class="dkt-description">${i18n('payment.primary.B2B.description')}</p>
    <div class="dkt-field" id="invoice-number-field">
      <label class="dkt-field-label" for="tb-invoice-number">${i18n('payment.primary.B2B.invoiceNumber')}&nbsp;:</label>
      <input type="text" class="dkt-textbox" id="tb-invoice-number"/>
      <span class="dkt-error-message">${i18n('payment.primary.B2B.invoiceNumber.errorMessage')}</span>
    </div>`;

  block.events = () => {
    block.header.addEventListener('click', block.select);
    document.addEventListener('clickedOnPay', block.check);
    document.addEventListener('PrimaryPaymentBlockSelected', block.unselect);
  };

  block.select = event => {
    if ((block.state.selected === false && event) || !event) {
      document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected',
        { bubbles: false, cancelable: false, detail: { 'multiEnabled': block.multiEnabled } }));

      $(block.content).slideDown('fast', () => {
        block.container.className += ' dkt-block--selected dkt-block--open';
      });
      block.state.selected = true;
      page.enableButton();
    }
  };

  block.unselect = () => {
    $(block.content).slideUp('normal', () => {
      block.container.classList.remove('dkt-block--selected');
      block.container.classList.remove('dkt-block--open');
    });
    block.state.selected = false;
  };

  block.check = () => {
    if (page.checkTermsOfUse() === false) return;
    if (page.checkBillingAddress && page.checkBillingAddress() === false) return;
    if (page.isFullSecondaryPayment && page.isFullSecondaryPayment() === true) return;

    if (block.state.selected === true) {
      if (block.fields.invoiceNumber.input.value.length < block.fields.invoiceNumber.max) {
        block.fields.invoiceNumber.container.classList.remove('dkt-field--error');
        block.submitPayment();
      } else {
        block.fields.invoiceNumber.container.classList.add('dkt-field--error');
      }
    }
  };

  block.submitPayment = () => {
    const params = {
      paymentTypeId: block.id,
      redirectionUrl: document.getElementById('redirectionUrl').value,
      orderAttributes: JSON.stringify(page.getAnalyticsInfos())
    };

    if (block.fields.invoiceNumber.input.value !== '') {
      params.invoiceNumber = block.fields.invoiceNumber.input.value;
    }
    params.useSecondaryMop = $('[data-role=secondary-payment-block]').hasClass('dkt-block--open');

    page.displayLoader();
    window.getAjaxHandler()
      .withUrl(formatUrl('applyPayment', block.orderId))
      .withParameters(params)
      .withSuccess(success)
      .call();

    function success(useless, response) {
      if (response && response.result && response.result.data) {
        const data = response.result.data;
        if (window.cube.config.anly_useLegacy === 'Y') {
          CUBE.Analytics.queue.send('proceedToConfirmation');
        }

        if (data.paymentModifiable === 'false') {
          window.location.reload();
        }

        if (data.redirectConfirmation === 'true') {
          window.location.href = data.redirectionUrl;
        }
      } else {
        page.hideLoader();
        page.displayError(response.responseTO.errors[0].message);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-b2b.js